import { render, staticRenderFns } from "./BusinessAppealCenter.vue?vue&type=template&id=81a5c95e&scoped=true&"
import script from "./BusinessAppealCenter.vue?vue&type=script&lang=js&"
export * from "./BusinessAppealCenter.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAppealCenter.vue?vue&type=style&index=0&id=81a5c95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a5c95e",
  null
  
)

export default component.exports